import React, { JSX } from 'react';
import { Typography } from '@mui/material';
import useAssetronHeadingStyles from './styles/useAssetronHeadingStyles';

interface AssetronHeadingProps {
  readonly title: string;
}

function AssetronHeading({ title }: AssetronHeadingProps): JSX.Element {
  const { TitleContainer } = useAssetronHeadingStyles();
  return (
    <Typography variant="large_heading_30_semibold" sx={TitleContainer}>
      {title}
    </Typography>
  );
}

export default AssetronHeading;
